import { computed } from 'mobx';

export default class RequestModel {
  id;
  store;

  constructor(store, request) {
    this.store = store;
    this.id = +request.id;
    this.daq_processor_id = request.daq_processor_id;
    this.daq_processor_parser = request.daq_processor_parser;
    this.daq_processor_protocol = request.daq_processor_protocol;
    this.timestamp = request.timestamp;
    this.payload = request.payload;
    this.raw_data = request.raw_data || [];
    this.origin_data = request.origin_data || [];
    this.observation = request.observation || [];
    this.request_errors = request.request_errors || [];
  }

  @computed get asJson() {
    return {
      id: +this.id,
      daq_processor_id: this.daq_processor_id,
      daq_processor_parser: this.daq_processor_parser,
      daq_processor_protocol: this.daq_processor_protocol,
      timestamp: this.timestamp,
      payload: this.payload,
      raw_data: this.raw_data,
      origin_data: this.origin_data,
      observation: this.observation,
      request_errors: this.request_errors,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.daq_processor_id = json.daq_processor_id;
    this.daq_processor_parser = json.daq_processor_parser;
    this.daq_processor_protocol = json.daq_processor_protocol;
    this.timestamp = json.timestamp;
    this.payload = json.payload;
    this.raw_data = json.raw_data || [];
    this.origin_data = json.origin_data || [];
    this.observation = json.observation || [];
    this.request_errors = json.request_errors || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/RequestModel.js